import { colors } from './colors';
//////////////////////////////////////////////////

const buttons = {
  primary: {
    borderRadius: '4px',
    border: '1px solid',
    color: colors.black,
    background: colors.lime,
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default',
    },
    '&:not(:disabled):hover': {
      border: '1px solid',
      color: colors.white,
      background: colors.black,
      borderColor: colors.white,
    },
  },
  primaryRound: {
    color: colors.black,
    borderRadius: '100px',
    background: colors.lime,
    '&:hover': {
      border: '1px solid',
      color: colors.white,
      background: colors.black,
      borderColor: colors.white,
      '&:hover svg path': { fill: colors.white },
    },
  },
  light: {
    borderRadius: '4px',
    color: colors.black,
    background: colors.white,
    '&:hover': {
      border: '1px solid',
      color: colors.white,
      background: colors.black,
      borderColor: colors.white,
    },
  },
  lightOutline: {
    color: colors.grey,
    border: '2px solid',
    borderRadius: '100px',
    background: colors.white,
    borderColor: colors.black,
    '&:hover': {
      color: colors.white,
      background: colors.black,
    },
  },
  error: {
    borderRadius: '4px',
    color: colors.white,
    background: colors.red,
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default',
    },
    '&:not(:disabled):hover': {
      background: colors.darkRed,
    },
  },
};

export { buttons };
